import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizAllBanner from "../../../../styles/img/quiz-all-banner.png";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBaner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr } from "../../components/common/UiPageElements";
import { UiRowContainer } from "../../components/grid-container/GridContainer";
import { QuizzerCard } from "./Views/QuizzerCard";
import volvoLogo from '../../../../styles/img/volvo-logo-round.png';
import Footer from "../../components/footer/Footer";


export const QuizzersCompleted = () => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBaner
                    title="Learning History"
                    description="See what courses you’ve completed!"
                    sliderCardImage={quizAllBanner} 
                    className="sb-knowldg-inner-banner"  /> 
 

                 <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="  Learning History"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-quizzers-all-sec">
                        <UiContentCol>
                            <div className="sb-quizzers-all-sec__nav">
                                <div className="sb-quizzers-all-sec-nav-link "> All Quizzes </div>
                                <div className="sb-quizzers-all-sec-nav-link active"> Completed </div>
                            </div>

                            <QuizzerCard
                                status="in-progress"
                                title="Quiz Name"
                                image={volvoLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                                warningBg={true}
                            />

                            <QuizzerCard
                                status="completed"
                                title="Quiz Name"
                                image={volvoLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                            <QuizzerCard
                                status="completed"
                                title="Quiz Name"
                                image={volvoLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                       


                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <Footer />
                
            </UiMainWrapper>
            

            </>
            )
}